export default {
  status: {
    open: 'Ouvert',
    closed: 'Fermé',
  },
  offline_until: "Hors ligne jusqu'à",
  closed_until: "Fermé jusqu'à",
  online_orders_paused: 'Commandes en ligne suspendues',
  online_orders_paused_until: "Commandes en ligne suspendues jusqu'à",
  reopens: 'Rouvre',
  opens_today: "Ouvre aujourd'hui",
  opens: 'Ouvre',
  open: 'Ouvert',
  open_whole_day: 'Ouvert toute la journée',
  outside_ordering_times: 'Hors des horaires de commande',
};
